/* unplugin-vue-components disabled */import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'credit-second-retain-popup',
    props: {
        value: Boolean
    },
    emits: [
        'close'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var userStore = useUserStore();
        var enterTime = ref(new Date());
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_auth_secdetain',
                    taskHandler: 'popup-show'
                }));
            } else {
                if (isClickContinueBtn.value) {
                    isClickContinueBtn.value = false;
                    return;
                }
                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_auth_secdetain',
                    taskHandler: isClickCloseBtn.value ? 'popup-close' : 'popup-quit',
                    eventIntervalSpan: new Date() - enterTime.value
                }));
                if (isClickCloseBtn.value) {
                    isClickCloseBtn.value = false;
                }
            }
        });
        var isClickContinueBtn = ref(false);
        var clickContinueBtn = function() {
            isClickContinueBtn.value = true;
            emit('close');
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                popKindName: 'popup_auth_secdetain',
                taskHandler: 'popup-continue'
            }));
        };
        var isClickCloseBtn = ref(false);
        var clickCloseBtn = function() {
            isClickCloseBtn.value = true;
            emit('close');
        };
        return {
            __sfc: true,
            userStore: userStore,
            props: props,
            emit: emit,
            enterTime: enterTime,
            isClickContinueBtn: isClickContinueBtn,
            clickContinueBtn: clickContinueBtn,
            isClickCloseBtn: isClickCloseBtn,
            clickCloseBtn: clickCloseBtn
        };
    }
};
